import React from 'react';
import BmbCta from '../BmbCta';
import MkPhone from '../MkPhone';
import MkPill from '../MkPill';
import bmbBreathing from '../../../assets/images/mk/mk-bmb-breathing-540.webp';
import bmbBreathing2x from '../../../assets/images/mk/mk-bmb-breathing-740.webp';
import bmbChoice from '../../../assets/images/mk/mk-bmb-choice-540.webp';
import bmbIntention from '../../../assets/images/mk/mk-bmb-intention-540.webp';
import bmbIcon from '../../../assets/images/mk/mk-bmb-icon-192.webp';

// B1 — the only <h1> on /bring-me-back. No reveal classes anywhere in the hero.
const BmbHero = ({ platform }) => (
  <section className="mk-bmbhero section" id="top" aria-labelledby="mk-bmbhero-title">
    <div className="container">
      <div className="mk-bmbhero__inner section-inner">
        <div className="mk-bmbhero__copy">
          <div className="mk-bmbhero__lockup">
            <img src={bmbIcon} alt="" width={88} height={88} />
            <p className="mk-bmb-lockup">Bring Me Back</p>
          </div>
          <p className="mk-bmbhero__pills">
            <MkPill variant="new">New</MkPill>
            <span>Companion app to Keep Me Out</span>
          </p>
          <h1 id="mk-bmbhero-title" className="mk-h1">
            A mindful pause before the apps that pull you in.
          </h1>
          <p className="mk-lead">Pause apps, block sites. Not to control you, but to bring you back.</p>
          <div id="mk-hero-cta" className="mk-bmbhero__cta">
            <BmbCta variant="badges" placement="bmb_hero" platform={platform} />
          </div>
          <p className="mk-micro mk-bmbhero__meta">Free to download for iPhone and Android.</p>
          <p className="mk-bmbhero__chips">
            <MkPill variant="platform">iPhone &amp; Android</MkPill>
            <MkPill variant="platform">7 pause types</MkPill>
            <MkPill variant="platform">Website filter runs on your phone</MkPill>
          </p>
          <p className="mk-micro mk-bmbhero__naming">Listed as "BringMeBack" on the App Store and Google Play.</p>
        </div>
        <div className="mk-bmbhero__visual">
          <div className="mk-drift">
            <div className="mk-bmbhero__stage">
              <span className="mk-bmbhero__ring" aria-hidden="true" />
              {/* The pause flow as a fan: ask (left) → breathe (front) → decide (right). Backs are decorative. */}
              <div className="mk-bmbhero__phone mk-bmbhero__phone--back" aria-hidden="true">
                <MkPhone src={bmbIntention} width={540} height={1095} framed alt="" />
              </div>
              <div className="mk-bmbhero__phone mk-bmbhero__phone--back mk-bmbhero__phone--right" aria-hidden="true">
                <MkPhone src={bmbChoice} width={540} height={1095} framed alt="" />
              </div>
              <div className="mk-bmbhero__phone mk-bmbhero__phone--front">
                <MkPhone
                  src={bmbBreathing}
                  srcSet={`${bmbBreathing} 540w, ${bmbBreathing2x} 740w`}
                  sizes="(max-width: 640px) 220px, 280px"
                  width={540}
                  height={1095}
                  framed
                  eager
                  priority
                  alt={'Bring Me Back breathing pause before Facebook, reading "Breathe out"'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BmbHero;
